import { alpha } from '@mui/material';

const styles = {
  card: {
    textAlign: 'center',
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
  },
  button: {
    height: '100%',
    whiteSpace: 'nowrap',
  },
  chart: {
    height: 350,
  },
  chartSlot: {
    legend: {
      hidden: true,
    },
  },
  legendContainer: {
    maxHeight: 250,
    overflowY: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  legendBox: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
